import { useNavigate } from 'react-router-dom';
import Button from '@components/forms/Button';
import StatusChip from '@components/widgets/StatusChip';
import { useAuthStore } from '@stores';
import { ReactComponent as NoBrokerOrgIcon } from '@assets/icons/no_broker_org.svg';

const cardClass = 'rounded-xl p-6';
const cardStyle = {
  backgroundColor: '#F9FAFB',
  boxShadow: '0 4px 24px rgba(3, 62, 115, 0.14), 0 1px 4px rgba(3, 62, 115, 0.08)',
};

const BrokerOrgBanner = () => {
  const { brokerOrgStatus } = useAuthStore();
  const navigate = useNavigate();

  if (brokerOrgStatus === 'ACTIVE') {
    return (
      <div className={cardClass} style={cardStyle}>
        <NoBrokerOrgIcon className="mb-3" />
        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-sm font-bold text-grey-900">Broker Organisation</h3>
          <StatusChip variant="success" label="Active" />
        </div>
        <p className="text-sm text-grey-500 leading-relaxed mb-5">
          Manage your organisation members, roles and invitations.
        </p>
        <Button
          className="w-full bg-secondary text-white normal-case text-sm font-semibold py-2.5 rounded-lg hover:bg-secondary-dark"
          onClick={() => navigate('/broker-org')}>
          Manage Organisation
        </Button>
      </div>
    );
  }

  if (brokerOrgStatus === 'PENDING') {
    return (
      <div className={cardClass} style={cardStyle}>
        <NoBrokerOrgIcon className="mb-3" />
        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-sm font-bold text-grey-900">Broker Organisation</h3>
          <StatusChip variant="info3" label="Under Review" />
        </div>
        <p className="text-sm text-grey-500 leading-relaxed">
          We're verifying your details. You'll be notified once approved.
        </p>
      </div>
    );
  }

  return (
    <div className={cardClass} style={cardStyle}>
      <NoBrokerOrgIcon className="mb-3" />
      <h3 className="text-sm font-bold text-grey-900 mb-2">Broker Organisation</h3>
      <p className="text-sm text-grey-500 leading-relaxed mb-5">
        Register your organisation to invite colleagues and manage your team's inspections in one place.
      </p>
      <Button
        className="w-full bg-secondary text-white normal-case text-sm font-semibold py-2.5 rounded-lg hover:bg-secondary-dark"
        onClick={() => navigate('/broker-org/register')}>
        Register Organisation
      </Button>
    </div>
  );
};

export default BrokerOrgBanner;
